"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonsForPauseEnum = void 0;
var ReasonsForPauseEnum;
(function (ReasonsForPauseEnum) {
    ReasonsForPauseEnum["MISCOUNDUCT"] = "Misconduct";
    ReasonsForPauseEnum["NO_CAPACITY"] = "Paused / no capacity";
    ReasonsForPauseEnum["NOT_INTERESTED"] = "Paused / not interested";
    ReasonsForPauseEnum["NO_PARTNER_EMAIL_REMINDER"] = "NO_PARTNER_EMAIL_REMINDER";
})(ReasonsForPauseEnum = exports.ReasonsForPauseEnum || (exports.ReasonsForPauseEnum = {}));
//# sourceMappingURL=reasons-for-pause-enum.js.map